<h3 class="title">Capital Call Details</h3>

<div class="border">
  <div class="header">
    <img [src]="paymentRequest.organizationLogoUrl" class="logo" alt="logo"/>
    <span class="header-description">{{paymentRequest.companyName}} is making a capital call due on {{paymentRequest.capitalCallDueDate | utcDate}}</span>
  </div>

  <ng-container *ngIf="!!paymentRequest.capitalCallPurpose">
    <span class="sub-title">Purpose of the call</span>
    <div class="purpose" [innerHTML]="paymentRequest.capitalCallPurpose"></div>
  </ng-container>

  <span class="sub-title investing-entity">Details for {{paymentRequest.investingEntity.name}}</span>
  <terra-lp-capital-call-details-line-item class="first-item" label="Initiated by" [value]="paymentRequest.companyName"></terra-lp-capital-call-details-line-item>
  <terra-lp-capital-call-details-line-item label="Date of Notice" [value]="paymentRequest.paymentRequestSendDate | date:'MM/dd/yyyy'"></terra-lp-capital-call-details-line-item>
  <terra-lp-capital-call-details-line-item class="highlight" label="Due Date" [value]="paymentRequest.capitalCallDueDate | utcDate:'MM/dd/yyyy'"></terra-lp-capital-call-details-line-item>
  <terra-lp-capital-call-details-line-item class="last-item highlight" label="Call Amount" value="{{paymentRequest.receiveCurrency.symbol}}{{paymentRequest.receiveAmount | terraNumber}}">
  </terra-lp-capital-call-details-line-item>

  <p class="country-input-title">Please choose the country where your bank account is located</p>

  <form class="country-form" [formGroup]="pageForm" (keydown.enter)="$event.preventDefault()">
    <div class="terra-form-field-wrapper country-selector">
      <terra-country-auto-complete inputId="aucCountryId" controlName="countryId" placeholderText="Select a country" [countriesList]="allCountries">
      </terra-country-auto-complete>
    </div>
  </form>

  <ng-container *ngIf="isLoadingDeliveryMethods$ | async else actions">
    <terra-loader></terra-loader>
  </ng-container>

  <ng-template #actions>
    <div class="actions" *ngIf="paymentDeliveryMethods$ | async as deliveryMethod">
      <a *ngIf="DeliveryMethod.isOn(deliveryMethod, DeliveryMethod.CovercyPayApp)" [disabled]="isViewingAsInvestor"
         [href]="payAppUrl" target="_blank" mat-button class="fund-commitment-button">
        International Transfer
      </a>

      <button *ngIf="DeliveryMethod.isOn(deliveryMethod, DeliveryMethod.AchDebit)" [disabled]="isViewingAsInvestor"
              (click)="openFundCommitmentDialog()" mat-button class="fund-commitment-button single-click-ach">
        ACH Debit
      </button>

      <button *ngIf="DeliveryMethod.isOn(deliveryMethod, DeliveryMethod.PDF)" (click)="downloadPdf()" mat-button class="fund-commitment-button">
        Bank Account Details
      </button>

      <p *ngIf="deliveryMethod === DeliveryMethod.None">
        Unable to process Capital Call, please contact support
      </p>
    </div>
  </ng-template>
</div>
